import { IconQuestion, Badge, Tooltip, cnMixSpace, Text } from 'uikit';

import { useCallback, useMemo, useRef, useState } from 'react';

import styles from './BimWorkOrderPriceCounter.module.css';

export const BimWorkOrderPriceCounter = ({
    priceListCounter,
    chaptersTooltip,
}: {
    priceListCounter: number | undefined;
    chaptersTooltip?: {
        chapter: string | null;
        priceCount: number | undefined;
    }[];
}) => {
    const ref = useRef(null);

    const [isTooltipVisible, setIsTooltipVisible] = useState(false);

    const priceListCounterMsg = useMemo(() => {
        if (!priceListCounter) {
            return 'Кол-во смет';
        }

        return `Смет ${priceListCounter}`;
    }, [priceListCounter]);

    const onMouseEnter = useCallback(() => {
        setIsTooltipVisible(true);
    }, []);

    const onMouseLeave = useCallback(() => {
        setIsTooltipVisible(false);
    }, []);

    return (
        <div ref={ref} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} className={cnMixSpace({ mR: 'm' })}>
            <Badge size="l" label={priceListCounterMsg} status="system" icon={IconQuestion} />
            {chaptersTooltip && isTooltipVisible && (
                <Tooltip anchorRef={ref} direction="upCenter" style={{ width: '120px' }}>
                    {chaptersTooltip.map((obj) => (
                        <Text size="s" className={styles.textTooltip} key={`${obj.chapter}_${obj.priceCount}`}>
                            <span className={cnMixSpace({ mR: '2xs' })}>{obj.chapter}</span>
                            <span className={styles.delimiter} />
                            <span className={cnMixSpace({ mL: '2xs' })}>{obj.priceCount}</span>
                        </Text>
                    ))}
                </Tooltip>
            )}
        </div>
    );
};

BimWorkOrderPriceCounter.displayName = 'BimWorkOrderPriceCounter';
